module.exports = __webpack_public_path__ + "static/scale-model-of-stranahan's-colorado-whiskey-in-denver-colorado-8647d1fbcdf7c5bbcc814dd013f63128.png";